/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Picker,
  Item,
  TextField,
  TextArea,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
} from '@adobe/react-spectrum';
import { Editor } from 'react-draft-wysiwyg';
import Select from 'react-select';
import PropTypes from 'prop-types';
import DateTime from '../DateTime';

import { EditorWrapper, EditorHeaderText } from '../../../pages/Brief/styles';
import { TimeSection, Section, MultiSelect } from './style';
import { getEstDateTime } from '../../../utils/utils';

function CustomField(props) {
  const {
    parameter,
    setDateObject,
    handleDateChange,
    dateObject,
    handleTimeChange,
    dynamicValues,
    handleDynamicChange,
    editorState,
    handleMultipleValues,
    handleChangeSelect,
    handleEditorChange,
    isProjectForm,
  } = props;
  switch (parameter.displayType) {
    case 'TEXT':
      return (
        <Section>
          {parameter.dataType === 'DTTM' ? (
            <Section>
              <span>
                <DateTime
                  name={`DE:${parameter.name}`}
                  isRequired={isProjectForm || false}
                  label={parameter.label}
                  onChange={date => {
                    setDateObject({
                      ...dateObject,
                      [parameter.name]: date,
                    });
                    handleDateChange(
                      `DE:${parameter.name}`,
                      getEstDateTime(date),
                    );
                  }}
                  value={dateObject[parameter.name] || new Date()}
                  selected={dateObject[parameter.name] || new Date()}
                  placeholderText="MM/DD/YYY"
                />
              </span>
              <TimeSection>
                <DateTime
                  name={`${parameter.name}Time`}
                  label=""
                  selected={dateObject[`${parameter.name}Time`] || new Date()}
                  onChange={date => {
                    setDateObject({
                      ...dateObject,
                      [`${parameter.name}Time`]: date,
                    });
                    handleTimeChange(
                      `DE:${parameter.name}`,
                      getEstDateTime(date),
                    );
                  }}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={5}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                />
              </TimeSection>
            </Section>
          ) : (
            <TextField
              name={parameter.name}
              label={parameter.label}
              isRequired={isProjectForm || false}
              value={dynamicValues[parameter.name]}
              onInput={event => {
                const {
                  target: { name, value },
                } = event;
                handleDynamicChange(name, value);
              }}
              placeholder=""
            />
          )}
        </Section>
      );
    case 'RICH':
      return (
        <EditorWrapper>
          <EditorHeaderText>{parameter.label}</EditorHeaderText>
          <Editor
            toolbar={{
              options: ['inline', 'list', 'blockType', 'link'],
              inline: {
                inDropdown: false,
                options: ['bold', 'italic', 'underline'],
              },
              blockType: {
                inDropdown: false,
                options: ['Blockquote'],
              },
              list: {
                options: ['unordered', 'ordered'],
              },
              link: {
                options: ['link'],
              },
            }}
            placeholder="Description of the project"
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            editorState={editorState[parameter.name] || ''}
            onEditorStateChange={value =>
              handleEditorChange(value, parameter.name)
            }
          />
        </EditorWrapper>
      );
    case 'TXTA':
      return (
        <Section>
          <TextArea
            name={parameter.name}
            label={parameter.label}
            isRequired={isProjectForm || false}
            value={dynamicValues[parameter.name]}
            onInput={event => {
              const {
                target: { name, value },
              } = event;
              handleDynamicChange(name, value);
            }}
            placeholder=""
            width="750px"
          />
        </Section>
      );
    case 'SLCT':
      return (
        <Section>
          <Picker
            label={parameter.label}
            items={parameter.parameterOptions}
            isRequired={isProjectForm || false}
            onSelectionChange={selected =>
              handleDynamicChange(parameter.name, selected)
            }
          >
            {item => <Item key={item.value}>{item.label}</Item>}
          </Picker>
        </Section>
      );
    case 'CHCK':
      return (
        <Section>
          <CheckboxGroup
            label={parameter.label}
            isRequired={isProjectForm || false}
            orientation="horizontal"
            onChange={value => {
              handleMultipleValues(parameter.name, value);
            }}
          >
            {parameter?.parameterOptions?.map(checkBoxOption => {
              return (
                <Checkbox value={checkBoxOption.value}>
                  {checkBoxOption.label}
                </Checkbox>
              );
            })}
          </CheckboxGroup>
        </Section>
      );
    case 'RDIO':
      return (
        <Section>
          <RadioGroup
            label={parameter.label}
            orientation="horizontal"
            onChange={value => {
              handleDynamicChange(parameter.name, value);
            }}
          >
            {parameter?.parameterOptions?.map((radioOption, index) => {
              return (
                <Radio
                  key={radioOption.value + index}
                  value={radioOption.value}
                >
                  {radioOption.label}
                </Radio>
              );
            })}
          </RadioGroup>
        </Section>
      );
    case 'MULT':
      return (
        <MultiSelect>
          <p className="_spectrum-FieldLabel_36b9b">
            {parameter.label}{' '}
            {isProjectForm ? <span className="asterisk">*</span> : ''}
          </p>
          <Select
            isMulti
            isSearchable={false}
            name={parameter.name}
            options={parameter.parameterOptions}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={selectedField =>
              handleChangeSelect(selectedField, parameter.name)
            }
          />
        </MultiSelect>
      );
    default:
      return '';
  }
}

CustomField.propTypes = {
  parameter: PropTypes.object,
  setDateObject: PropTypes.func,
  handleDateChange: PropTypes.func,
  dateObject: PropTypes.object,
  handleTimeChange: PropTypes.func,
  dynamicValues: PropTypes.object,
  handleDynamicChange: PropTypes.func,
  editorState: PropTypes.object,
  handleMultipleValues: PropTypes.func,
  handleChangeSelect: PropTypes.func,
  handleEditorChange: PropTypes.func,
  isProjectForm: PropTypes.bool,
};

CustomField.defaultProps = {
  parameter: {},
  setDateObject: () => {},
  handleDateChange: () => {},
  dateObject: {},
  handleTimeChange: () => {},
  dynamicValues: {},
  handleDynamicChange: () => {},
  editorState: {},
  handleMultipleValues: () => {},
  handleChangeSelect: () => {},
  handleEditorChange: () => {},
  isProjectForm: false,
};

export default CustomField;
